/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerRegion } from '../../models/partner-region';

export interface GetPartnerRegions$Params {
}

export function getPartnerRegions(http: HttpClient, rootUrl: string, params?: GetPartnerRegions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerRegion>>> {
  const rb = new RequestBuilder(rootUrl, getPartnerRegions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PartnerRegion>>;
    })
  );
}

getPartnerRegions.PATH = '/partnerregion';
